import React from 'react';

const RefundCancellation = () => {
    return (
        <div className="refund-cancellation-page">
            <section className="policy-content-section">
                <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '3rem 1.5rem' }}>
                    <h1 style={{
                        color: '#069668',
                        fontSize: '2.5rem',
                        marginBottom: '3rem',
                        textAlign: 'center'
                    }}>Refund / Cancellation Policy</h1>
                    <div className="policy-last-updated" style={{ marginBottom: '2rem', color: '#666' }}>
                        <p><strong>Last Updated:</strong> April 16, 2026</p>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>1. Overview</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            At Yathartha, we strive to provide the best financial advisory services. This Refund and Cancellation
                            Policy outlines the terms under which refunds and cancellations are processed for our paid services.
                        </p>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>2. Cancellation Policy</h2>
                        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '1rem' }}>
                            You may cancel your service request under the following conditions:
                        </p>
                        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '2rem' }}>
                            <li><strong>Before Service Delivery:</strong> Cancellation requests made before the financial diagnosis report is generated will be processed with a full refund.</li>
                            <li><strong>After Service Delivery:</strong> Once the financial diagnosis report has been delivered, cancellations are not accepted as the service has been fully rendered.</li>
                            <li><strong>Subscription Services:</strong> For ongoing subscription services, you may cancel at any time. The cancellation will be effective from the next billing cycle.</li>
                        </ul>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>3. Refund Policy</h2>
                        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '1rem' }}>
                            Refunds are processed under the following circumstances:
                        </p>
                        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '2rem' }}>
                            <li><strong>Service Not Delivered:</strong> If the service is not delivered within the promised timeframe (7 working days), you are eligible for a full refund.</li>
                            <li><strong>Technical Issues:</strong> If technical errors prevent you from accessing the delivered report, a full refund or service re-delivery will be provided.</li>
                            <li><strong>Duplicate Payment:</strong> In case of accidental duplicate payments, the excess amount will be refunded within 5-7 working days.</li>
                            <li><strong>Incorrect Service:</strong> If you receive a service different from what was ordered, you are eligible for a refund or correction.</li>
                        </ul>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>4. Non-Refundable Cases</h2>
                        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '1rem' }}>
                            Refunds will NOT be provided in the following cases:
                        </p>
                        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '2rem' }}>
                            <li>Change of mind after the service has been delivered</li>
                            <li>Dissatisfaction with the financial recommendations (as these are based on the information provided by you)</li>
                            <li>Failure to provide accurate or complete information affecting the quality of the diagnosis</li>
                            <li>Services partially utilized or reports partially accessed</li>
                        </ul>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>5. Refund Process</h2>
                        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '1rem' }}>
                            To request a refund:
                        </p>
                        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '2rem' }}>
                            <li>Email us at <strong>connect.yathartha@gmail.com</strong> with subject line "Refund Request"</li>
                            <li>Include your registered name, phone number, payment reference, and reason for refund</li>
                            <li>Refund requests will be processed within 5-7 working days after verification</li>
                            <li>Refunds will be credited to the original payment method used during purchase</li>
                        </ul>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>6. Processing Time</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            Approved refunds will be processed within 5-7 working days. The time for the refund
                            to reflect in your account may vary depending on your bank or payment provider, typically
                            ranging from 5 to 10 business days.
                        </p>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>7. Contact for Refund/Cancellation</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            For any questions regarding refunds or cancellations, please contact us:
                        </p>
                        <p style={{ lineHeight: '1.8', color: '#333', marginTop: '1rem' }}>
                            <strong>Email:</strong> connect.yathartha@gmail.com<br />
                            <strong>Phone:</strong> +91 7218377377<br />
                            <strong>Working Hours:</strong> Monday to Saturday, 10:00 AM - 6:00 PM IST
                        </p>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>8. Policy Updates</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            We reserve the right to modify this Refund/Cancellation Policy at any time. Changes will be
                            effective immediately upon posting on this page. Please review this policy periodically.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default RefundCancellation;
